module.exports = __webpack_public_path__ + "/login_ui/img/cv-045e4bb225ee23a07a1e5d04bcf55bd2.svg";